import _ from 'lodash'
import type {VariantSplit} from '@wix/document-services-types'

const VARIANTABLE_DATA_ITEM_KEYS = new Set(['default', 'variants'])

export const isVariantSplit = (value: unknown): value is VariantSplit => {
    return (
        _.isPlainObject(value) &&
        !_.isEmpty(value) &&
        Object.keys(value as Record<string, any>).every(key => VARIANTABLE_DATA_ITEM_KEYS.has(key))
    )
}
